import { Settings } from './../settings/settings';
import { AnalyticsService } from './../analytics/analytics.service';
import { CartItem } from './../cart/cartItem';
import { environment } from './../../environments/environment';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, NgZone, OnDestroy, Output, Input, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GiftSelection } from '../gift/giftSelection';
import { RegistryService } from '../registry/registry.service';
import { CartService } from '../cart/cart.service';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { Cart } from '../cart/cart';
import { ConfigurationService } from '../shared/configuration.service';
import { Registry } from './../registry/registry';
import { Gift } from '../gift/gift';
import { GuestWish } from '../gift-wish/wish';
import { NgForm } from '@angular/forms';
import { PaymentService } from '../payment/payment.service';
import { TranslatorService } from '../translator/translator.service';
import { ImageUrlService } from '../shared/services/image-url.service';



// declare var stripe: any;
// declare var Stripe: any;
// declare var elements: any;

// elements;
declare var Stripe;
@Component({

  selector: 'app-gift-payment',
  templateUrl: './gift-payment.component.html',
  styleUrls: ['./gift-payment.component.scss']

})

export class GiftPaymentComponent implements OnInit, OnDestroy {
  @Input() amount: number;
  @Input() description: string;
  manualTransferMode: string;
  manualTransferModeFriendlyText: string;
  email: string;
  contributionId: string;
  guestEmail: string;
  bankTitleField1: string;
  preview: boolean = false;
  paymentMode: string;
  bankTitleField2: string;
  hasStripeAndCustomPaymentMethods = false;
  bankTitleField3: string;
  giftTitle: string;
  bank1Label: string;
  bank2Label: string;
  bank3Label: string;
  showTranslation = false
  bankTitleField4: string;
  showStripeForm: boolean = false;
  manualAgreeCheckbox = false;
  @ViewChild('cardInfo') cardInfo: ElementRef;
  @ViewChild('cardNumberEl') cardNumberEl: ElementRef;
  @ViewChild('cardExpEl') cardExpEl: ElementRef;
  @ViewChild('cardCcvEl') cardCcvEl: ElementRef;
  @ViewChild('paymentRequestButton') paymentRequestButton: ElementRef;
  paymentRequest: any;
  cardExp: any;
  cardCcv: any;
  whenWillGuestPay: string;
  card: any;
  eeaCountries = [
    'AT',
    'BG',
    'BE',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO'
  ];

  error: string;
  settings: Settings;

  giftSelection: GiftSelection;
  cardNumber: any;
  expiryMonth: string;
  user: User;
  price = 0;
  expiryYear: string;
  cvc: string;
  // error: string;
  audFee = 0;
  nonAudFee = 0;
  stripe; // : stripe.Stripe;
  cardErrors;

  loading = false;
  confirmation;
  stripeInitialized = false;

  fixedFee = 0;
  percentFee = 0;


  private errorText: string;
  public hitchdForm: FormGroup;
  public guestFeePercent: number;
  procesing: boolean;
  loaded = false;
  private formattedYear: any;
  registry: Registry;
  @Input() isCart = false;
  fee = 0;
  @Output() itemPayed: EventEmitter<any>;
  currency: string;
  numOfCustomPaymentMethods = 0;
  idepontent_key: string;
  symbol: string;
  stripeConnected = false;
  cart: Cart;
  guestWish: GuestWish;
  gifts: Gift[];
  isLoggedIn: boolean;
  anonymousMode = false;
  grandTotal = 0;
  fees = {
    OTHER: { Percent: 2.9, Fixed: 0.30 },
    AUD: { Percent: 1.57, Fixed: 0.30 },
  };
  idepontent_key_time: number;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private registryService: RegistryService,
    private cartService: CartService,
    private _fb: FormBuilder,
    private validatorService: CustomValidatorsService,
    private _zone: NgZone,
    private _configurationService: ConfigurationService,
    private _analyticsService: AnalyticsService,
    private _authService: AuthService,
    private cd: ChangeDetectorRef,
    private _paymentService: PaymentService,
    private _translatorService: TranslatorService,
    private _registryFirebaseService: RegistryFirebaseService,
    private imageUrlService: ImageUrlService
  ) {
    // Initialize settings object to prevent template errors
    this.settings = new Settings();

    if (localStorage.getItem('showTranslation')) {
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }
    this.guestWish = this.registryService.wish;
    if ((location.search.includes('preview'))) {
      // this.router.navigate(["coming-soon"]);
      this.preview = true;

      this.anonymousMode = false;
      if (location.pathname.includes('your-registry')) {
        this.anonymousMode = true;
      }
    }

    this.itemPayed = new EventEmitter<any>();

    this.idepontent_key_time = new Date().getTime();




  }
  onInputBlur(event) {

    this.giftSelection.isEditing = false;

  }

  isEea(country) {
    return this.eeaCountries.includes(country);
  }


  loadCard() {
    // this.cardNumber = elements.create('cardNumber')
    // this.cardCcv = elements.create('cardCvc')
    // this.cardExp = elements.create('cardExpiry')
    // this.paymentRequest = elements.create('paymentRequestButton')\\


    this.card = (window as any).elements.create('card', {
      hidePostalCode: true,
      hideIcon: true,
      iconStyle: 'solid',
      style: {
        base: {
          iconColor: '#393C3C',
          color: '#393C3C',
          fontWeight: 400,
          fontSize: '16px',
          fontSmoothing: 'antialiased',
          ':-webkit-autofill': {
            color: '#393C3C',
          },
          '::placeholder': {
            color: '#898A8A',
            letterSpacing: '0',
          },
        },
        invalid: {
          iconColor: 'red',
          color: 'red',
        },
      },
    });
    if (this.cardInfo && this.cardInfo.nativeElement) {
      this.card.mount(this.cardInfo.nativeElement);
    }
    // this.cardNumber.mount(this.cardNumberEl.nativeElement);
    // this.cardExp.mount(this.cardExpEl.nativeElement);
    // this.cardCcv.mount(this.cardCcvEl.nativeElement);

  }

  /**
   * Centralized method to initialize Stripe with proper account configuration
   * Only initializes when all required conditions are met
   */
  private initializeStripe(): boolean {
    console.log('🔄 initializeStripe() called', {
      stripeInitialized: this.stripeInitialized,
      hasRegistry: !!this.registry,
      hasSettings: !!this.settings,
      isPreview: this.preview,
      registryPaid: this.registry ? this.registry.paid : undefined,
      stripeAccountId: this.settings ? this.settings.stripeAccountId : undefined
    });

    // In preview mode, skip if already properly initialized to prevent multiple card element creation
    if (this.preview && this.stripeInitialized) {
      console.log('🚫 Preview mode: Stripe already initialized, skipping');
      return true;
    }

    // Always reinitialize to ensure fresh DOM bindings
    console.log('🔄 Reinitializing Stripe for fresh DOM bindings');

    // Check if we have the registry data
    if (!this.registry) {
      console.log('❌ No registry data available yet');
      return false;
    }

    try {
      if (this.preview) {
        // Preview mode: only initialize if user has Stripe configured or using fake Stripe
        if (this.settings && this.settings.stripeAccountId) {
          console.log('🎭 Initializing Stripe for preview mode');
          (window as any).stripe = Stripe(environment.stripePublicKey, {
            stripeAccount: this.settings.stripeAccountId
          });
          this.stripeInitialized = true;
        } else {
          console.log('🚫 Skipping Stripe initialization - no stripeAccountId in preview mode');
          return false;
        }
      } else if (this.settings) {
        // Production mode: check if we need connected account
        if (this.registry.paid && this.settings.stripeAccountId) {
          // Use connected account for paid registries
          console.log('💳 Initializing Stripe with connected account:', this.settings.stripeAccountId);
          (window as any).stripe = Stripe(environment.stripePublicKey, {
            stripeAccount: this.settings.stripeAccountId,
          });
          this.stripeInitialized = true;
        } else if (!this.registry.paid) {
          // Use platform account for legacy registries
          console.log('🏛️ Initializing Stripe with platform account (legacy registry)');
          (window as any).stripe = Stripe(environment.stripePublicKey, {});
          this.stripeInitialized = true;
        } else {
          // Paid registry but settings.stripeAccountId is missing - retry settings load
          console.log('⚠️ Paid registry missing stripeAccountId, retrying settings load');
          this.retrySettingsLoad();
          return false;
        }
      } else {
        // Settings not loaded yet
        console.log('⏳ Settings not loaded yet');
        return false;
      }

      // Create elements instance
      (window as any).elements = (window as any).stripe.elements();

      // Load the card element with a delay to ensure DOM is ready
      setTimeout(() => {
        this.loadCard();
      }, 100);

      console.log('✅ Stripe successfully initialized');
      return true;
    } catch (error) {
      console.error('Failed to initialize Stripe:', error);
      this.stripeInitialized = false;
      return false;
    }
  }

  ngOnDestroy() {

    if (this.card) {
      this.card.destroy();
    }
    this.registryService.giftTitle = '';
  }

  openPopup(popupType) {

    ;
    this.registryService.emitGenricPopup(popupType);
  }
  launchClick() {

    this.openPopup('anon_signup');
  }

  createHashKey(email, giftId, amount, time) {


    const data = `${email}${giftId}${amount}${time}`;
    const base64 = btoa(data);
    return base64
  }


  async onSubmit(form: NgForm) {
    let idepontent_key = this.createHashKey(this.guestWish.email, this.giftSelection.gift.id, this.giftSelection.price, this.idepontent_key_time);

    // The stripe account should already be set correctly when the stripe instance was created
    // No need to modify _stripeAccount here as it can cause payment method account mismatches

    this.error = '';
    this.procesing = true;
    (window as any).stripe.createPaymentMethod('card', this.card, {
      billing_details: {
        name: this.registryService.wish.yourName, email: this.registryService.wish.email,
        address: {
          country: this.hitchdForm.controls['billingCountry'].value
        }
      },

    }).then((result) => {
      if (result.error) {
        this.procesing = false;
        this.error = result.error.message;
        this.idepontent_key_time = new Date().getTime();

        // Show error in payment form
      } else {


        // Otherwise send paymentMethod.id to your server (see Step 2
        const cartItems = this.getCartItems();
        let paymentString = JSON.stringify({
          payment_method_id: result.paymentMethod.id,
          cart: cartItems,
          oldReg: !this.registry.paid,
          name: this.registryService.wish.yourName,
          email: this.registryService.wish.email,
          registryId: this.registry.id,
          wish: this.registryService.wish,
          billingCountry: this.hitchdForm.controls['billingCountry'].value,
          idepontent_key: idepontent_key
        });



        this._paymentService.ConfirmPayment(paymentString)
          .subscribe((response) => {
            if (response._body) {
              const responseResult = JSON.parse(response._body);
              this.handleServerResponse(responseResult);
            } else if (response.error) {
              this.error = response.error;
              this.idepontent_key_time = new Date().getTime();
              this.procesing = false;
              if (this.error === 'Your card was declined.') {
                this.error = 'Your card was declined, please check your payment details and ensure the country matches the country of the credit card';
              }
              return;
            } else {
              this.paymentComplete();
            }
          });
      }
    });
  }



  setManualTransferMode() {
    this.manualTransferMode = null;
    if (this.registry.wise) {

      this.manualTransferMode = 'wise';
    } else if (this.registry.venmo) {
      this.manualTransferMode = 'venmo';
    } else if (this.registry.cashApp) {
      this.manualTransferMode = 'cashApp';
    } else if (this.registry.zelle) {
      this.manualTransferMode = 'zelle';
    } else if (this.registry.revolut) {
      this.manualTransferMode = 'revolut';
    } else if (this.registry.paypal) {
      this.manualTransferMode = 'paypal';
    } else if (this.registry.bitcoin) {
      this.manualTransferMode = 'bitcoin';
    } else if (this.registry.bankField1) {
      this.manualTransferMode = 'bank';
    } else if (this.registry.payId) {
      this.manualTransferMode = 'payId';
    } else if (this.registry.cashOnTheDay) {
      this.manualTransferMode = 'cashOnTheDay';
    } else if (this.registry.chequeOnTheDay) {
      this.manualTransferMode = 'chequeOnTheDay';
    } else if (this.registry.customInstructions) {
      this.manualTransferMode = 'customInstructions';
    }

  }

  countCustomPaymentMethods() {
    ///

    if (this.showStripeForm) {
      this.paymentMode = 'stripe';
      this.manualTransferMode = 'stripe';
    }


    this.numOfCustomPaymentMethods = 0;
    if (this.registry.hasCustomPaymentMethods) {
      this.setPaymentMethodTitles();


      if (this.registry.cashApp) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'cashApp';
      }

      if (this.registry.paypal) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'paypal';
      }


      if (this.registry.venmo) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'venmo';
      }


      if (this.registry.customInstructions) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'customInstructions';
      }
      if (this.registry.bitcoin) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'bitcoin';
      }
      if (this.registry.bankField1) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'bank';
      }
      if (this.registry.bank2Field1) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'bank2';
      }

      if (this.registry.bank3Field1) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'bank3';
      }

      if (this.registry.zelle) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'zelle';
      }

      if (this.registry.revolut) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'revolut';
      }

      if (this.registry.cashOnTheDay) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'cashOnTheDay';
      }


      if (this.registry.payId) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'payId';
      }

      if (this.registry.wise) {
        this.numOfCustomPaymentMethods++;

        this.manualTransferMode = 'wise';
      }
      if (this.registry.chequeOnTheDay) {
        this.numOfCustomPaymentMethods++;
        this.manualTransferMode = 'chequeOnTheDay';
      }

      if (this.showStripeForm) {
        this.paymentMode = 'stripe';
        this.manualTransferMode = 'stripe';
      }

    }
  }

  setPaymentMethodTitles() {
    this.bankTitleField1 = null;
    this.bankTitleField2 = null;
    this.bankTitleField3 = null;
    this.bankTitleField4 = null;
    const titles = this.registryService.getBankFieldTitles(this.registry.country);
    this.bankTitleField1 = titles.field1;
    this.bankTitleField2 = titles.field2;
    this.bankTitleField3 = titles.field3;
    this.bankTitleField4 = titles.field4;
  }

  titleCase(str: string) {
    return str.toLowerCase().split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  }
  ngOnInit() {


    this.giftSelection = new GiftSelection();
    this.registry = this.route.snapshot.data.registry;

    if (this.registry.bankField1) {
      this.bank1Label = this._translatorService.getCountryAdjective(this.registry.bankCountry ? this.registry.bankCountry : this.registry.country) + " Bank Transfer";
      this.bank1Label = this.titleCase(this.bank1Label);
    }
    if (this.registry.bank2Field1) {
      this.bank2Label = this._translatorService.getCountryAdjective(this.registry.bank2Country) + " Bank Transfer";
      this.bank2Label = this.titleCase(this.bank2Label);

    }
    if (this.registry.bank3Field1) {
      this.bank3Label = this._translatorService.getCountryAdjective(this.registry.bank3Country) + " Bank Transfer";
      this.bank3Label = this.titleCase(this.bank3Label);

    }

    if (this.preview) {
      // For preview mode, load actual settings if registry is paid, otherwise use fake settings
      if (this.registry.paid) {
        // Load real settings for paid registry preview
        this._registryFirebaseService.getSettingsViaReg(this.registry).subscribe(settings => {
          if (settings) {
            this.settings = settings;

            if (this.settings && this.settings.stripeAccountId && this.settings.chargesEnabled) {
              this.showStripeForm = true;
            } else if (this.settings && this.settings.merchantId) {
              this.showStripeForm = true;
            }

            this.countCustomPaymentMethods();
            this.initPaymentDisplay();
            this.calculateNewFees();
            this.calcGrandTotal();

            if (settings.stripeAccountId) {
              this.initializeStripe();
            }
          }
        });
      } else {
        // Use fake settings for unpaid registry preview
        this.stripeConnected = true;
        this.settings = new Settings();
        this.settings.stripeAccountId = "fakeaccountId_preview";
        this.showStripeForm = true;
        this.manualTransferMode = 'stripe';
        this.initializeStripe();

        this.countCustomPaymentMethods();
        if (this.showStripeForm) {
          this.paymentMode = 'stripe';
          this.manualTransferMode = 'stripe';
        } else if (this.numOfCustomPaymentMethods >= 1) {
          this.paymentMode = 'manual';
          this.setManualTransferMode();
        }
      }
    } else {

      this._registryFirebaseService.getSettingsViaReg(this.registry).subscribe(settings => {
        if (settings) {
          this.settings = settings;

          if (this.settings && this.settings.stripeAccountId && this.settings.chargesEnabled) {
            this.showStripeForm = true;
          } else if (this.settings && this.settings.merchantId) {
            this.showStripeForm = true;
          }


          //console.log(this.settings.stripeAccountId);
          this.countCustomPaymentMethods();



          this.initPaymentDisplay();



          this.calculateNewFees();
          this.calcGrandTotal();
          if (settings.stripeAccountId || location.search.includes('preview')) {
            // Use centralized initialization
            this.initializeStripe();
          }
        }
      });
    }
    // this.countCustomPaymentMethods();



    this.isLoggedIn = this.route.snapshot.data.isLoggedIn;
    this.gifts = this.route.snapshot.data.gifts;
    this.symbol = this.registry.symbol;
    this.currency = this.registry.currency;

    this._authService.user.subscribe(x => {
      this.user = x;
      if (this.user) {
        this._registryFirebaseService.getSettings().subscribe(settings => {
          if (settings) {


            this.stripeConnected = settings.stripeAccountId != null;
            this.settings = settings;
            this.countCustomPaymentMethods();
            this.setManualTransferMode();
            this.initPaymentDisplay();
            if (this.numOfCustomPaymentMethods == 0 && this.settings && this.settings.stripeAccountId) {
              this.manualTransferMode = 'stripe';
            }

            if (this.registry && (location.search.includes('preview'))) {
              // this.router.navigate(["coming-soon"]);
              this.preview = true;


            }
            ;
            if (this.numOfCustomPaymentMethods == 0 && this.settings && !this.settings.stripeAccountId && this.preview) {
              this.settings.stripeAccountId = "fakeaccountId_preview";
              this.showStripeForm = true;
              this.manualTransferMode = 'stripe';
            }
            this.calculateNewFees();
            this.calcGrandTotal();

            // Try to initialize Stripe only if Stripe is configured
            if (this.settings && this.settings.stripeAccountId) {
              this.initializeStripe();
            }
          }
        });
      } else {
        this.countCustomPaymentMethods();
        this.setManualTransferMode();
        this.stripeConnected = true;
      }
    });


    // this.giftSelection = new GiftSelection();
    const giftname = this.registryService.giftTitle;

    if (!this.guestWish) {
      if (this.isLoggedIn) {
        this.router.navigate(giftname
          ? ['/registry', giftname]
          : ['/registry']);
      } else if (this.preview) {


        if (location.hostname.includes('localhost')) {
          this.guestWish = new GuestWish();
          this.guestWish.yourName = "Guest";
          this.guestWish.email = "ifonseka1@gmail.com";
          this.guestWish.registryId = this.registry.id;
          this.guestWish.contribution = "test";
          this.guestWish.fromNames = "test";
          this.guestWish.wishText = "test";
        } else {
          this.router.navigateByUrl('/registry/' + this.registry.registryName.toLocaleLowerCase() + "?preview=true");
        }


      }

      else {
        this.router.navigateByUrl('/' + this.registry.registryName.toLocaleLowerCase());
      }
      return;
    }

    if (!this.isCart) {
      this.giftSelection = this.registryService.getGiftSelection(giftname, this.gifts);

      this.price = this.giftSelection.price;
      // console.log('123444');

      this.registryService.SetServiceFee(this.registry);
      this.guestFeePercent = this.registry.guestFeePercent;
      this.loaded = true;

    } else {

      this.cart = this.cartService.getCart();


      this.guestFeePercent = this.registry.guestFeePercent;
      //   console.log('aaaaa');
      this.cartService.changeEmitted$.subscribe(updatedCart => this.cart = updatedCart);
      this.loaded = true;

    }
    //if (!this.registry.hasCustomPaymentMethods){
    this.hitchdForm = this._fb.group({
      //email: ['', [Validators.required, Validators.minLength(5), this.validatorService.validateEmail]],
      names: [this.guestWish.yourName, [Validators.required, Validators.maxLength(200)]],
      billingCountry: [this.registry.country]
    });
    this.calculateNewFees();
    this.calcGrandTotal();
    //}
  }

  cartChanged(item: Cart) {
    this.cart = item;
  }

  giftTotal(): number {
    //console.log('giftTotal');
    if (this.isCart) {
      const sum = this.cart.cartItems.reduce((x, cv) => x + cv.price, 0);
      // const sumValues = (obj) =>  this.cartItems(obj).reduce((acc, value) => acc + obj[value], 0);
      return sum;
    } else {
      return this.price;
    }

  }

  // couple
  // case 1: { return 8; }
  //     case 2: { return 4; }
  //     case 3: { return 0; }

  calculateFee(): number {

    if (this.manualTransferMode != 'stripe') {
      return 0;
    }
    if (this.preview) {
      return 0;
    }
    const total = this.giftTotal();

    const fee = (total * this.guestFeePercent / 100);

    return fee;

  }

  initPaymentDisplay() {
    if (this.numOfCustomPaymentMethods == 0 && this.settings && (this.settings.stripeAccountId || this.settings.merchantId)) {
      this.manualTransferMode = 'stripe';
      this.paymentMode = 'stripe';
    } else if (this.numOfCustomPaymentMethods > 1 && !this.showStripeForm) {
      this.manualTransferMode = null;
      this.paymentMode = 'manual';
      this.setManualTransferMode();
    } else if (this.numOfCustomPaymentMethods >= 1 && (this.showStripeForm)) {
      this.hasStripeAndCustomPaymentMethods = true;
      this.manualTransferMode = 'stripe';
      this.paymentMode = 'stripe';
    } else if (this.numOfCustomPaymentMethods == 1 && !this.showStripeForm) {
      this.manualTransferMode = null;
      this.paymentMode = 'manual';
      this.setManualTransferMode();
    }
  }

  getFees(country, cardCountry) {
    //console.log('getFees ')


    if (this.manualTransferMode != 'stripe') {
      return 0;
    }

    if (this.settings && this.settings.merchantId) {
      this.percentFee = 3.94;
      this.fixedFee = 0;
      return;
    }

    const isCardCountryEea = this.isEea(cardCountry);
    const isCountryEea = this.isEea(country);


    function getIntFeeByDate(gmtOffset, priceBeforeApr10, priceAfterApr10) {
      const april10_2023_utc = new Date(2023, 3, 10, 0, 0, 0).getTime(); // April 10, 2023 midnight UK time
      const april10_2023_gmt = april10_2023_utc + gmtOffset * 60 * 1000; // Add 1 hour to convert to UTC
      if (Date.now() >= april10_2023_gmt) {
        return priceAfterApr10;
      } else {
        return priceBeforeApr10;
      }
    }



    switch (country) {
      case 'GB': {
        if (cardCountry === 'GB') {
          this.percentFee = 1.5;
        } else if (isCardCountryEea) {
          this.percentFee = 2.5
        } else {
          this.percentFee = getIntFeeByDate(1, 2.9, 3.25)

        }
        this.fixedFee = .2;
        break;
      }
      case 'IE': {
        if (cardCountry === 'GB') {
          this.percentFee = 2.5;
        } else if (isCardCountryEea) {
          this.percentFee = 1.5
        } else {
          this.percentFee = 3.25

        }
        this.fixedFee = 0.25
        break;
      }

      case 'DK': {
        this.fixedFee = 1.8;
        if (isCardCountryEea) {
          this.percentFee = 1.5;
        } else if (cardCountry === 'GB') {
          this.percentFee = 2.5;
        } else {
          this.percentFee = getIntFeeByDate(-2, 2.9, 3.25)

        }
        break;
      }
      case 'NO': {
        this.fixedFee = 2;
        this.percentFee = 2.4;
        if (cardCountry == "NO" || isCardCountryEea) {
          this.percentFee = 2.4;
        } else if (cardCountry != 'NO') {
          this.percentFee = getIntFeeByDate(-2, 2.9, 3.25);
        }
        break;
      }
      case 'MX': {
        this.fixedFee = 3;
        this.percentFee = 3.6;
        break;
      }
      case 'CH': {
        this.fixedFee = 0.3;
        //////////// UP TO HERE
        if (cardCountry === 'CH') {
          this.percentFee = 2.9;
        } else {
          this.percentFee = getIntFeeByDate(2, 2.9, 3.25);
        }

        break;
      }
      case 'AU': {
        if (cardCountry === 'AU') {
          this.percentFee = 1.7;
        } else {
          this.percentFee = 3.5;
        }
        this.fixedFee = .3;
        break;
      }
      case 'SE': {
        this.fixedFee = 1.8;
        if (isCardCountryEea) {
          this.percentFee = 1.5;
        } else if (cardCountry === 'GB') {
          this.percentFee = 2.5;
        } else {
          this.percentFee = getIntFeeByDate(1, 2.9, 3.25);
        }
        break;
      }
      case 'US': {
        if (cardCountry === 'US') {
          this.percentFee = 2.9;
        } else {
          //if date is after june1 2023 and date is -8 gmt then this.percentFee should be 3.9 otherwise it should be 2.9+1.5;
          const june1_2023_utc = new Date(2023, 5, 1, 0, 0, 0).getTime(); // April 10, 2023 midnight UK time
          const june1_2023_gmtUS = june1_2023_utc + -7 * 60 * 1000; // Add 1 hour to convert to UTC
          if (Date.now() >= june1_2023_gmtUS) {
            return 4.4;
          } else {
            return 3.9;
          }

        }
        this.fixedFee = .3;
        break;
      }

      case 'CA': {
        if (cardCountry === 'CA') {
          this.percentFee = 2.9;
        } else {
          this.percentFee = 3.5;
        }
        this.fixedFee = .3;
        break;
      }
      ///// UP TO HERE
      case 'JP': {
        if (cardCountry === 'JP') {
          this.percentFee = 3.6;
        } else {
          this.percentFee = 3.6;
        }
        this.fixedFee = 0;
        break;
      }

      case 'NZ': {
        this.fixedFee = 0.3;
        if (cardCountry === 'NZ') {
          this.percentFee = 2.7;
        } else {
          this.percentFee = 2.9;
        }
        break;
      }
      case 'SG': {
        this.percentFee = 3.4;
        this.fixedFee = 0.5;
        break;
      }
      case 'HK': {
        this.percentFee = 3.4;
        this.fixedFee = 2.35;
        break;
      }
      default: {
        if (isCountryEea) {
          this.fixedFee = 0.25;
          if (isCardCountryEea) {
            this.percentFee = 1.5;
          } else if (cardCountry === 'GB') {
            this.percentFee = 2.5;
          } else {
            this.percentFee = 3.25;
            break;
          }
        }
      }

    }



  }

  calculateNewFees() {
    const total = this.giftTotal();

    //      console.log('calculateNewFees ')
    if (!this.hitchdForm || !this.hitchdForm.controls || !this.hitchdForm.controls['billingCountry'].value) {
      return;
    }

    if (this.settings && this.settings.feeOption === 3) {
      if (this.registry.paid !== undefined) {

        this.getFees(this.registry.country, this.hitchdForm.controls['billingCountry'].value);
      } else if (this.settings && this.settings.merchantId) {
        this.fixedFee = 0;
        this.percentFee = 3.94;
        this.fee = (this.percentFee / 100) * total;
        return;
      } else {
        this.fixedFee = 0;
        this.percentFee = 8;
        this.fee = (this.percentFee / 100) * total;
        return;
      }

      this.fee = (total + this.fixedFee) / (1 - (this.percentFee / 100)) - total;

      if (this.registry.country == 'IE') {

        const ieVATRate = 1.23;

        // Calculate X
        const giftAmountWithFeeAndVat = (total + this.fixedFee * ieVATRate) / (1 - this.percentFee * ieVATRate / 100);
        this.fee = giftAmountWithFeeAndVat - total;
        //round this.fee to 2 decimal palces
        this.fee = Math.round(this.fee * 100) / 100;

      } else if (this.registry.country === 'IT') {
        const itVATRate = 1.22;
        const giftAmountWithFeeAndVat = (total + this.fixedFee * itVATRate) / (1 - this.percentFee * itVATRate / 100);
        this.fee = giftAmountWithFeeAndVat - total;
        //round this.fee to 2 decimal palces
        this.fee = Math.round(this.fee * 100) / 100;
      }

    } else if (this.settings && this.settings.feeOption === 2 && this.settings.merchantId) {
      this.fixedFee = 0;

      // NEW SPLIT LOGIC: Match backend calculation exactly
      // Step 1: Calculate couple fee (1.97% of gift amount)
      const FEE_PERCENT = this.percentFee;
      const coupleFee = total * (FEE_PERCENT / 2) / 100; // $1.97 for $100 gift

      // Step 2: Calculate guest payment for exactly 3.94% total fee rate
      // Formula: guestPayment = (giftTotal - coupleFee) / (1 - FEE_PERCENT/100)
      const guestPayment = (total - coupleFee) / (1 - FEE_PERCENT / 100);

      // Step 3: Calculate guest fee
      const guestFee = guestPayment - total;
      this.fixedFee = 0;
      this.fee = Math.round(guestFee * 100) / 100; // Round to 2 decimal places
      this.percentFee = 3.94; // Keep as full rate for display purposes

      return;
    }
    else if (this.settings && this.settings.feeOption === 3) {
      this.fee = 0;
    }

    if (this.manualTransferMode != 'stripe') {
      this.fee = 0;
    }
    this.grandTotal = this.giftTotal() + this.fee;
  }
  calcGrandTotal() {
    //  console.log('calcGrandTotal ')
    const giftTotal = this.giftTotal();

    this.grandTotal = giftTotal + this.fee;
    if (this.registry.paid !== undefined) {
      this.calculateNewFees();
      this.grandTotal = giftTotal + this.fee;
    } else {
      this.fee = this.calculateFee();
      this.grandTotal = giftTotal + this.fee;
    }
  }

  getBankInstructionString(bankTitleField1, bankTitleField2, bankTitleField3, bankTitleField4, bankField1, bankField2, bankField3, bankField4) {
    if (this.manualTransferMode == 'bank') {
      if (bankTitleField1 && bankTitleField2 && bankTitleField3 && !bankField4) {
        return `<strong>${bankTitleField1}:</strong> ${bankField1} <br><strong>${bankTitleField2}:</strong> ${bankField2}<br> <strong>${bankTitleField3}:</strong> ${bankField3}`;
      } if (bankTitleField1 && bankTitleField2 && bankTitleField3 && bankField4) {
        return `<strong>${bankTitleField1}:</strong> ${bankField1} <br><strong>${bankTitleField2}:</strong> ${bankField2}<br> <strong>${bankTitleField3}:</strong> ${bankField3}<br> <strong>${bankTitleField4}:</strong> ${bankField4}`;
      }
      else if (bankTitleField1 && bankTitleField2 && !bankTitleField3) {
        return `<strong>${bankTitleField1}:</strong> ${bankField1} <br><strong>${bankTitleField2}:</strong> ${bankField2}`;
      } else if (bankTitleField1 && !bankTitleField2 && !bankTitleField3) {
        return `<strong>${bankTitleField1}:</strong> ${bankField1}`;
      } else if (bankTitleField1 && !bankTitleField2 && !bankTitleField3) {
        return `<strong>${bankTitleField1}:</strong> ${bankField1}`;
      }

    }
  }

  getInstructions() {

    switch (this.manualTransferMode) {
      case 'cashApp':
        return this.registry.cashApp;
      case 'paypal':
        return this.registry.paypal;
      case 'venmo':
        return this.registry.venmo;
      case 'bitcoin':
        return this.registry.bitcoin;
      case 'bank': {
        let title = this.registryService.getBankFieldTitles(this.registry.bankCountry);
        return this.getBankInstructionString(title[0], title[1], title[2], title[3], this.registry.bankField1, this.registry.bankField2, this.registry.bankField3, this.registry.bankField4)
      }
      case 'bank2': {
        let title = this.registryService.getBankFieldTitles(this.registry.bank2Country);
        return this.getBankInstructionString(title[0], title[1], title[2], title[3], this.registry.bank2Field1, this.registry.bank2Field2, this.registry.bank2Field3, this.registry.bank2Field4)
      }
      case 'bank3': {
        let title = this.registryService.getBankFieldTitles(this.registry.bank3Country);
        return this.getBankInstructionString(title[0], title[1], title[2], title[3], this.registry.bank3Field1, this.registry.bank3Field2, this.registry.bank3Field3, this.registry.bank3Field4)
      }
      case 'customInstructions':
        return this.registry.customInstructions;


      case 'revolut':
        return this.registry.revolut;

      case 'zelle':
        return this.registry.zelle;

      case 'cashOnTheDay':
        return this.registry.cashOnTheDay;
      case 'chequeOnTheDay':
        return this.registry.chequeOnTheDay;

      case 'payId':
        return this.registry.payId;

      case 'wise':
        return this.registry.wise;



      default:
        break;
    }

    if (this.registry.cashApp) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'cashApp';
    }

    if (this.registry.bitcoin) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'bitcoin';
    }


    if (this.registry.paypal) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'paypal';
    }


    if (this.registry.venmo) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'venmo';
    }


    if (this.registry.customInstructions) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'customInstructions';
    }


    if (this.registry.bankField1) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'bank';
    }


    if (this.registry.cashOnTheDay) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'cashOnTheDay';
    }


    if (this.registry.chequeOnTheDay) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'chequeOnTheDay';
    }


    if (this.registry.revolut) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'revolut';
    }
    if (this.registry.zelle) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'zelle';
    }
    if (this.registry.payId) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'payId';
    }
    if (this.registry.wise) {
      this.numOfCustomPaymentMethods++;
      this.manualTransferMode = 'wise';
    }

  }

  markAsPaid() {
    const cartItems = this.getCartItems();
    this.procesing = true;
    this.contributionId = this.manualTransferMode + this.registryService.wish.email.substr(0, 5) + '_' + new Date().getTime();
    this._paymentService.MarkAsPaid(JSON.stringify({
      payment_intent_id: this.manualTransferMode + this.registryService.wish.email.substr(0, 5) + '_' + new Date().getTime(),
      cart: cartItems,
      name: this.registryService.wish.yourName,
      email: this.registryService.wish.email,
      registryId: this.registry.id,
      oldReg: !this.registry.paid,
      wish: this.registryService.wish,
      paymentMethod: this.manualTransferMode,
      paymentInstructions: this.getInstructions(),
      isManualContribution: true,
      whenWillGuestPay: this.whenWillGuestPay,

    }))

      .subscribe((httpResult) => {
        if (httpResult._body) {
          const responseResult = JSON.parse(httpResult._body);
          this.handleServerResponse(responseResult);
        } else if (httpResult.error) {
          this.error = httpResult.error;
          this.idepontent_key_time = new Date().getTime();
          this.procesing = false;
          return;
        } else {
          this.paymentComplete();
        }
      });
  }

  addToCart() {
    const giftId = this.giftSelection.gift.id;
    this.cartService.addToCart(this.giftSelection.gift, this.price);
    this.router.navigate(['/']);
  }

  onSelect() {
    this.router.navigate(['/' + this.giftSelection.gift.friendlyUrl.toLowerCase(), 'wish']);

  }

  initAddress() {
    return this._fb.group({
      street: ['', Validators.required],
      postcode: ['']
    });
  }

  addAddress() {
    const control = <FormArray>this.hitchdForm.controls['addresses'];
    control.push(this.initAddress());
  }

  removeAddress(i: number) {
    const control = <FormArray>this.hitchdForm.controls['addresses'];
    control.removeAt(i);
  }

  getCartItems(): Array<CartItem> {
    let cartItems = Array<CartItem>();
    if (this.isCart) {
      cartItems = this.cart.cartItems;
    } else {
      const cartItem = new CartItem();
      cartItem.gift = this.giftSelection.gift;
      cartItem.price = this.price;
      cartItem.giftId = cartItem.gift.id;
      cartItems.push(cartItem);
    }
    return cartItems;

  }
  handleServerResponse = async (response) => {
    if (response.error) {
      // Show error from server on payment form
    } else if (response.requires_action) {
      // Use Stripe.js to handle the required card action
      const { error: errorAction, paymentIntent } =
        await stripe.handleCardAction(response.payment_intent_client_secret);

      if (errorAction) {
        this.error = 'You have rejected this payment - please try again';
        this.idepontent_key_time = new Date().getTime();
        this.procesing = false;
      } else {
        const cartItems = this.getCartItems();

        this._paymentService.ConfirmPayment(JSON.stringify({
          payment_intent_id: paymentIntent.id,
          cart: cartItems,
          name: this.registryService.wish.yourName,
          // email: this.hitchdForm.controls['email'].value,
          registryId: this.registry.id,
          oldReg: !this.registry.paid,
          wish: this.registryService.wish,
          billingCountry: this.hitchdForm.controls['billingCountry'].value,

        }))
          .subscribe((httpResult) => {
            if (httpResult._body) {
              const responseResult = JSON.parse(httpResult._body);
              this.handleServerResponse(responseResult);
            } else if (httpResult.error) {
              this.error = httpResult.error;
              this.procesing = false;
              return;
            } else {
              this.paymentComplete();
            }
          });
      }
    } else {
      this.paymentComplete();
    }
  }

  color() {
    if (this.giftSelection.gift) {
      return this.registryService.getColor(this.giftSelection.gift.imageUrl);
    }
  }

  getGiftImageUrl() {
    if (this.giftSelection && this.giftSelection.gift && this.giftSelection.gift.imageUrl) {
      return this.imageUrlService.getStandardImageUrl(this.giftSelection.gift.imageUrl);
    }
    return '';
  }

  goToWish() {
    let returnAddress = "/" + this.registry.registryName;
    if (location.href.toLowerCase().includes('/registry/')) {
      returnAddress = "/" + this.registry.registryName + "/registry"
    }
    if (this.preview) {
      const currentPath = window.location.pathname;
      const newPath = currentPath.split('/').slice(0, -1).join('/');

      this.router.navigateByUrl(newPath + '/wish' + '?preview=1');
      return;
    }
  }
  goToGift() {
    let urlPath = "";
    if (this.preview) {
      urlPath = "?preview=1"
    }
    this.router.navigateByUrl('/' + this.registry.registryName + "/" + this.giftSelection.gift.friendlyUrl.toLowerCase() + urlPath);
  }
  backToRegistry() {
    const currentUrl = location.href.toLowerCase();
    const hasPreview = currentUrl.includes('preview=1');
    let returnAddress = '';

    // Check if URL contains /registry/
    if (currentUrl.includes(`/${this.registry.registryName}/registry`)) {
      returnAddress = `/${this.registry.registryName}/registry`;
    } else if (currentUrl.includes(`/${this.registry.registryName}`)) {
      returnAddress = `/${this.registry.registryName}`;
    }

    // Append preview parameter if it exists in current URL
    if (hasPreview) {
      returnAddress += '?preview=1';
    }

    this.router.navigateByUrl(returnAddress);
  }

  exitPreview() {
    this.router.navigateByUrl('/registry');
  }
  paymentComplete() {
    this.cartService.clearCart();
    this.registryService.setWishSent(true);
    this.registryService.setGiftSelection(null);

    if (this.isLoggedIn) {
      this.router.navigate(['/registry']);
    } else {
      const summary = {
        isManualContribution: this.manualTransferMode && this.manualTransferMode != 'stripe' ? true : false,
        whenWillGuestPay: this.whenWillGuestPay,
        manualTransferPaymentMethod: this.manualTransferMode,
        fee: this.fee,
        payment: this.price,
        total: this.grandTotal,
        id: this.contributionId,
        guestEmail: this.guestWish.email,
        guestFirstName: this.registryService.wish.yourName,

      };
      localStorage.setItem('contrib', JSON.stringify(summary));
      let returnAddress = "/" + this.registry.registryName;
      if (location.href.toLowerCase().includes('/registry/')) {
        returnAddress = "/" + this.registry.registryName + "/registry"
      }
      let urlPath = returnAddress + '/contribution-success';
      if (this.preview) {
        urlPath = urlPath + "?preview=1"
      }

      this.router.navigateByUrl(urlPath)
    }
  }

  private retrySettingsLoad(): void {
    console.log('🔄 Retrying settings load for stripeAccountId');

    // Force a fresh settings load from Firebase
    this._registryFirebaseService.getSettingsViaReg(this.registry).subscribe(settings => {
      if (settings && settings.stripeAccountId) {
        console.log('✅ Settings reload successful, found stripeAccountId:', settings.stripeAccountId);
        this.settings = settings;

        // Update showStripeForm flag
        if (this.settings.stripeAccountId && this.settings.chargesEnabled) {
          this.showStripeForm = true;
        }

        // Retry Stripe initialization
        setTimeout(() => {
          this.initializeStripe();
        }, 100);
      } else {
        console.log('❌ Settings reload failed, still missing stripeAccountId');
      }
    });
  }
}








// WEBPACK FOOTER //
// ./src/app/gift-payment/gift-payment.component.ts